import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { bestPerformingArticlesShowAllText } from '@epicuro-next/constants/features/localization';
import { IFilterValue } from '@epicuro-next/data/reporting-api';

@Component({
  selector: 'epc-dashboard-filter-select',
  templateUrl: './dashboard-filter-select.component.html',
  styleUrls: ['./dashboard-filter-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DashboardFilterSelectComponent {
  @Input() public filterValues: IFilterValue[] = [];

  @Input() public selectedValues: string[] = [];

  @Input() public defaultText: string;

  @Input() public isSingle = false;

  @Input() public showValueAsLabelText = false;

  @Input()
  public showAllText: string = bestPerformingArticlesShowAllText;

  @Output()
  public filterChanged = new EventEmitter<string[] | null>();

  public selectedValuesText() {
    return this.showValueAsLabelText
      ? this.selectedValues
          .map(
            (key) =>
              this.filterValues.find((filterValue) => filterValue.key === key)
                ?.value,
          )
          .join(',')
      : this.selectedValues?.join(',');
  }
  public isSelected(key: string) {
    return this.selectedValues?.some((x: string) => x === key);
  }

  public trackByValue(_: number, item: IFilterValue) {
    return item.key;
  }

  protected filterSelected(key: string | null) {
    if (!key) {
      this.filterChanged.emit([]);
      return;
    }

    let newValues: string[] = [];
    if (!this.isSingle) {
      newValues = this.selectedValues.filter((x) => x !== key);
    }
    if (!this.isSelected(key)) {
      newValues.push(key);
    }
    this.filterChanged.emit(newValues);
  }
}
